import { Checkbox } from "construct-ui";
import moment from "moment";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import { formats as FORMATS } from "../../config/constants";
import loginModel from "../../models/login.model";
import surveyModel from "../../models/survey/survey.model";
import ViewBase from "../view-base.view";

export default function SurveyResultDownloadView() {

  ViewBase.call(this);

  const INCLUDE_PHOTOS_BY_DEFAULT_COUNTRY = ['NZ'];

  let isDownloading = false;
  let filter = {
    surveyIds: "",
    fromDate: "",
    toDate: "",
    allQuestionYN: "N",
    excludeImageYN: "Y",
    isWithPhotos: INCLUDE_PHOTOS_BY_DEFAULT_COUNTRY.includes(loginModel.credentials.country),
  }

  let responsePeriod = {
    fromDate: moment().add(-6, 'd').format(FORMATS.apiDateFormat),
    toDate: moment().format(FORMATS.apiDateFormat),
    isAll: false,
  }

  let responseQuestions = {
    isAll: false,
  }

  let closeModal = function () { }

  let handleResponsePeriodRadio = (e) => {
    responsePeriod.isAll = e.target.value === 'all';
  }

  let handleResponseQuestionsRadio = (e) => {
    responseQuestions.isAll = e.target.value === 'all';
  }

  let download = (e) => {
    e.preventDefault();
    if (isDownloading) {
      return false;
    }
    isDownloading = true;

    if (responsePeriod.isAll) {
      filter.fromDate = "";
      filter.toDate = "";
    } else {
      filter.fromDate = responsePeriod.fromDate;
      filter.toDate = responsePeriod.toDate;
    }

    filter.allQuestionYN = responseQuestions.isAll ? 'Y' : 'N';

    surveyModel.downloadSurveyResults(
      (result) => {
        isDownloading = false;
      },
      (error) => {
        isDownloading = false;
        this.handleError(error);
      },
      filter
    );
    return false;
  }

  return {
    oninit: (vnode) => {
      if (typeof vnode.attrs.closeModal === 'function') {
        closeModal = vnode.attrs.closeModal;
      }
      if (vnode.attrs.surveyIdList) {
        filter.surveyIds = vnode.attrs.surveyIdList.join('^');
      }
    },
    view: (vnode) => {
      return m('.container',
        m('.row.g-4',
          m('.col-12',
            m('label.form-label', this.getText("LT00000526", "Response Period")),
            m('.d-flex.flex-column.gap-2.ps-2',
              m('.form-check',
                m('input.form-check-input#period[type=radio][name=responsePeriod][value=""]', {
                  checked: !responsePeriod.isAll,
                  onclick: handleResponsePeriodRadio
                }),
                m(DatePickerComponent, {
                  class: 'form-control',
                  isRange: true,
                  dateStart: moment(responsePeriod.fromDate, FORMATS.apiDateFormat).format(FORMATS.dateFormat), // default date range
                  dateEnd: moment(responsePeriod.toDate, FORMATS.apiDateFormat).format(FORMATS.dateFormat), // default date range
                  readonly: true,
                  onselect: (e) => {
                    responsePeriod.fromDate = moment(e.detail.start).format(FORMATS.apiDateFormat);
                    responsePeriod.toDate = moment(e.detail.end).format(FORMATS.apiDateFormat);
                  }
                })
              ),
              m('.form-check',
                m('input.form-check-input#allPeriod[type=radio][name=responsePeriod][value="all"]', {
                  checked: responsePeriod.isAll,
                  onclick: handleResponsePeriodRadio
                }),
                m('label.form-check-label[for=allPeriod]', this.getText("", "All")),
              ),
            ),
          ),
          m('.col-12',
            m('label.form-label', this.getText("LT00000527", "Response Questions")),
            m('.d-flex.flex-column.gap-2.ps-2',
              m('.form-check',
                m('input.form-check-input#answeredOnly[type=radio][name=responseQuestions][value=""]', {
                  checked: !responseQuestions.isAll,
                  onclick: handleResponseQuestionsRadio
                }),
                m('label.form-check-label[for=answeredOnly]', this.getText("LT00000528", "Answered only")),
              ),
              m('.form-check',
                m('input.form-check-input#allQuestions[type=radio][name=responseQuestions][value="all"]', {
                  checked: responseQuestions.isAll,
                  onclick: handleResponseQuestionsRadio
                }),
                m('label.form-check-label[for=allQuestions]', this.getText("LT00000143", "All")),
              ),
            ),
          ),
          m('.col-12',
            m(Checkbox, {
              class: 'mt-1',
              checked: filter.isWithPhotos,
              label: this.getText("LT00000990", "Include photos"),
              onchange: (e) => {
                filter.isWithPhotos = e.target.checked;
              },
            }),
          )
        ),
        m('.d-flex.justify-content-end.gap-3.mt-4.mb-2',
          // Download button
          m('.input-group.w-auto',
            m('button.btn.btn-primary[type=button]',
              { onclick: download },
              (isDownloading)
                ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
                : m('i.bi.bi-file-earmark-arrow-down-fill'),
              this.getText("LT00000492", "Download")
            ),
          ),
          m('button.btn.btn-white[type=button]', { onclick: closeModal }, this.getText("LT00000021", "Close")),
        ),
        this.getBaseViews()
      )
    }
  }
}